import moment from 'moment';

import useSearchBar from '@contexts/searchbar';

import FlightDatePicker from './FlightDatePicker';

const DateSelection = ({
  isTravelPlanning,
}: {
  isTravelPlanning?: boolean;
}) => {
  const {
    state: { flight: state },
  } = useSearchBar();

  const start = state?.startDate ? moment(state?.startDate) : null;
  const end = state?.endDate ? moment(state.endDate) : null;

  return (
    <FlightDatePicker
      isTravelPlanning={isTravelPlanning}
      initialDates={{
        startDate: start,
        endDate: end,
      }}
    />
  );
};

export default DateSelection;
